import React, { MouseEvent } from 'react';

import Text from 'components/atoms/text';
import { SystemLogGeneral } from 'container/services/systemLogs/ISystemLogsRepo';
import { capitalize } from 'utils/formatters/string';

import { getStatusIcon, TEXTS } from './config';
import sm from './styles.module.scss';

type RedirectHandler = (event: MouseEvent<HTMLElement>) => void;

const LogsStatusCell = (data: SystemLogGeneral) => (
  <div className={sm.StatusWrapper}>
    <img
      className={sm.StatusWrapper_Icon}
      src={getStatusIcon(data?.logType)}
      alt={TEXTS.ALT.STATUS}
    />
    <Text content={capitalize(String(data?.logType ?? ''))} />
  </div>
);

const RenderLink = (text: string, onClickHandler: RedirectHandler) => (
  <div
    role="button"
    tabIndex={0}
    className={sm.Link}
    onKeyDown={(e) => e.preventDefault()}
    onClick={onClickHandler}
  >
    {text}
  </div>
);

export { LogsStatusCell, RenderLink };
